export enum ABRStatusConstants {
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  NO_SHOW = "NO_SHOW"
}

export enum PaymentGatewayConstant {
  BILLDESK = "billdesk",
  RAZORPAY = "razorpay",
  OFFLINE = "offline"
}
